/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_LabelInputs */



/**
* | output |
* | --- |
* | "Download data export" |
*
* @param {Admin_Export_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_export_label = /** @type {((inputs?: Admin_Export_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger l'export des données")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar la exportación de datos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar exportação de dados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica l'export dei dati")
	return /** @type {LocalizedString} */ ("Download data export")
});